'use strict';

import React from "react";
import Message from "./message.jsx";
import MessageStandAlone from "./messageStandalone.jsx";
import Moment from "moment";

import Notification from "../../../../commonModules/interface/Notif";
import { MiniCard } from "../../../../commonModules/layouts/CardPage.jsx";
import { CommentRounded, SendRounded } from "@material-ui/icons";
import { TextArea } from "../../../../commonModules/interface/form-input-inline.jsx";
import { Button, Box } from "@material-ui/core";
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
var $ = require('jquery');

class Messaging extends React.Component {
    constructor(props) {
        super(props);
        this.setFiles.bind(this);
        this.state = {
            //Information
            messages: [],
            focused: false,
            files: [],
            newMessage: '',
            method: 'app', //OR sms
            messageType: 'Envoyer un message à l\'utilisateur...',
            messagesInstantList: [],
            sendingMode: "zmdi zmdi-comment-dots",

            smsChecked: false,

            notif:{
                title:"", 
                type:"", 
                message:"",
                display:"hidden"
            }
        };
    }
    componentDidMount() {
        var methodName = 'Get Last Messages';
        var url = "/message/system/all?boxAssoId=" + this.props.boxAssoId + "&timeFrom=&timeTo=";

        this.serverRequest = $.get(url, function (result) {
            console.log('[INFO], ', methodName,' with ',result);
            console.log(result);
            var messagesList = [];
            try {
                var data = result;
                messagesList = data.content;
            } catch (e) {
                // les instructions utilisées pour gérer les exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                return;
            }
            console.log('List Of Msg',messagesList);
            this.setState({messages: messagesList});
        }.bind(this));
    }
    SendMessage = (e) =>  {
        e.preventDefault();
        console.log("Send Messages :", this.state.newMessage);
        var methodName = 'Push Message';
        if (this.state.newMessage === "" || typeof this.state.newMessage === 'undefined' ){
            this.setState({
                notif:{
                    title:"Erreur", 
                    type:"danger", 
                    message:"Message non correcte",
                    display:"fadeInDown"
                }
            })
            return
        }
        var url = "message/add?method=" + this.state.method + "&boxAssoId=" + this.props.boxAssoId + "&content=" + this.state.newMessage + "&userType=admin" + "&time=" + Moment()
            .utc()
            .format();
        var messagesInstantList = this.state.messagesInstantList;
        var newMsg = this.state.newMessage;
        this.serverRequest = $.get(url, function (result) {
            console.log('[INFO], ', methodName);
            console.log(result);
            var resp = '';
            try {
                var data = result;
                resp = data.error;
            } catch (e) {
                // les instructions utilisées pour gérer les exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                this.setState({
                    notif:{
                        title:"Erreur", 
                        type:"danger", 
                        message:"Internal Error",
                        display:"fadeInDown"
                    }
                })
                return;
            }
            if (resp === "OK") {
                var obj = {'content':newMsg,'date':Moment().utc().format('DD/MM/YYYY à hh:mm:ss')};
                var res = messagesInstantList.push(obj);
                
                this.setState({
                    newMessage: '',
                    messagesInstantList: messagesInstantList
                });
            } else {
                console.log('[ERROR], Pushing message,', resp);
                this.setState({
                    notif:{
                        title:"Erreur", 
                        type:"danger", 
                        message:"le message n'a pu être envoyé : "+resp,
                        display:"fadeInDown"
                    }
                })
            }

        }.bind(this));
    }
    ChangeMsg = (e) => {
        e.preventDefault();
        this.setState({newMessage: e.target.value})
    }
    setFiles = (e) => {
        let imgs = [];
        let list = e.target.files;
        console.log(list);
        for (let i = 0; i < list.length; ++i)
        {
            imgs = [...imgs, list[i].name];
        }
        console.log(imgs);
        // list.map(file => {
        //     files = [...files, file.name]
        // });
        this.setState({ files: imgs });
    }
    changeModeSMS = () => {
        // e.preventDefault();
        // this.setState({newMessage: e.target.value})

        // if (this.state.sendingMode === "zmdi zmdi-comment-dots"){
        //     this.setState({sendingMode: "zmdi zmdi-comment-dots c-red",method:"sms"})
        // }else{
        //     this.setState({sendingMode: "zmdi zmdi-comment-dots",method:"app"})
        // }        
        const { method } = this.state;
        let newMethod = method === "sms" ? "app" : "sms"
        console.log("[INFO], changeModeSMS, smsChecked, ",this.state.smsChecked)
        this.setState({ method: newMethod ,smsChecked: !this.state.smsChecked})
    }
    render() {
        var messagesList = [];
        var messagesInstantListTmp = [];
        console.log('====================================');
        console.log(this.state.method);
        console.log('====================================');
        console.log('Instant',this.state.messagesInstantList);
        if (this.state.messages.length >= 1) {
            console.log('[INFO], render Message List',this.state.messages);            
            this
                .state
                .messages
                .forEach(function (info) {
                    messagesList.push(<Message key={info} messageId={info} pointOfView="admin"/>);
                }.bind(this));
        }

        if (this.state.messagesInstantList.length >= 1) {
            this
            .state
            .messagesInstantList
            .forEach(function (info) {
                messagesInstantListTmp.push(<MessageStandAlone key={info.content} messageTime={info.date} Message={info.content} sender="admin"/>);
            }.bind(this));
        }
        //Propose Instant Messafge List
        console.log('Files: ');
        this.state.files.map(file => {
            console.log(file);
        });
        // console.log('Files: ', this.state.files);
        return (
            <MiniCard
                title="Messages"
                avatar={<CommentRounded /> }
                submitButton={
                    <Button endIcon={<SendRounded />} onClick={this.SendMessage}>
                        Envoyer
                    </Button>
                }
            >
                <Box p={1}>
                    { this.state.files.length > 0 && this.state.files.map((file, id) => {
                        // console.log('====> SINGLE FILE <==== ', file);
                        <p style={{fontSize: '25px', color: 'black', background: 'white', fontWeight: 'bold'}} key={id}>{file}</p>
                        })
                    }
                </Box>
                <div className="listview lv-message">
                    
                     <div className="lv-header-alt clearfix">
                        <div id="ms-menu-trigger">
                            <div className="line-wrap">
                                <div className="line top"></div>
                                <div className="line center"></div>
                                <div className="line bottom"></div>
                            </div>
                        </div>

                        <div className="lvh-label hidden-xs">
                            <div className="lv-avatar pull-left">
                                <img src="/img/profile-pics/1.jpg" alt=""/>
                            </div>
                            <span className="c-black">Conversation utilisateur</span>
                        </div>

                        <ul className="lv-actions actions">
                        <FormControlLabel
                                control={ <Checkbox
                                defaultChecked
                                color="primary"
                                checked={this.state.smsChecked}
                                name="Envoi par SMS"
                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                onChange={ this.changeModeSMS }
                            />
                            }
                             label="Envoi par SMS"
                            />
                        </ul>
                    </div> 
                   

                    <div className="lv-body">
                        {messagesList}
                        {messagesInstantListTmp}
                    </div>    

                    <div className="lv-footer ms-reply">
                        <TextArea
                            placeholder={this.state.messageType}
                            value={this.state.newMessage}
                            onChange={this.ChangeMsg}
                        />

                        

                    </div>
                </div>
                <Notification 
                    display={this.state.notif.display} 
                    title={this.state.notif.title} 
                    type={this.state.notif.type} 
                    message={this.state.notif.message} 
                    close={()=> this.setState({
                        notif:{
                            ...this.state.notif,
                            display:"fadeOutUp"
                        }
                    })} 
                />
            </MiniCard>

        )
    }
};
export default Messaging
